import React from "react"
import _ from "lodash"
import { List, Text, Separator } from "native-base"
import I18n from "i18n"
import EmptyList from "components/views/Shared/EmptyList"
import OfferRequestListItem from "../OfferRequestListItem"
import styles from "./styles"
import { Navigation } from "components/types"

interface Props {
  offerRequestIds: string[]
  navigation: Navigation
}

export default class OfferRequestsList extends React.Component<Props> {
  shouldComponentUpdate(nextProps: Props) {
    return !_.isEqual(nextProps.offerRequestIds, this.props.offerRequestIds)
  }

  render() {
    const { offerRequestIds = [], navigation } = this.props
    return (
      <List style={styles.list}>
        <Separator style={styles.separator}>
          <Text style={styles.separatorText}>
            {I18n.t("open_offer_requests").toUpperCase()}
          </Text>
        </Separator>
        {offerRequestIds.length ? (
          offerRequestIds.map((item, idx) => (
            <OfferRequestListItem
              key={`${item}_offer_request_list_item`}
              last={offerRequestIds.length === idx + 1}
              offerRequestId={item}
              navigation={navigation}
            />
          ))
        ) : (
          <EmptyList emptyTextMessage={I18n.t("empty_offer_request_list")} />
        )}
      </List>
    )
  }
}
